// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3znFW","left":"InfoRow_left__3zehA"};